// services/sales/CreditFiscalSaleService.ts
import { creditFiscalSaleApi } from '../../api';
import { CreditFiscalProduct, CreditFiscalProductUpdate } from '../../types/sale/CreditFiscalSale';


const CreditFiscalSaleService = {
  /**
   * POST /api/credit-fiscal-sales/products
   * Agrega un producto a una venta con crédito fiscal.
   */
  addProduct: async (product: CreditFiscalProduct) => {
    const response = await creditFiscalSaleApi.addCustom('/products', product);
    return response.data;
  },

  /**
   * PUT /api/credit-fiscal-sales/products
   * Actualiza un producto de una venta con crédito fiscal.
   */
  updateProduct: async (product: CreditFiscalProductUpdate) => {
    const response = await creditFiscalSaleApi.modifyCustom('/products', product);
    return response.data;
  },

  /**
   * DELETE /api/credit-fiscal-sales/products/{detailId}
   * Elimina un producto de una venta con crédito fiscal.
   */
  deleteProduct: async (detailId: number) => {
    const response = await creditFiscalSaleApi.removeCustom(`/products/${detailId}`);
    return response.data;
  },

  /**
   * GET /api/credit-fiscal-sales/products/{detailId}
   * Obtiene un producto para edición.
   */
  getProductById: async (detailId: number) => {
    const response = await creditFiscalSaleApi.fetchCustom(`/products/${detailId}`);
    return response.data;
  },
};

export default CreditFiscalSaleService;
